import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
/* Tooltip */
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';
import DeleteIcon from '@material-ui/icons/DeleteOutline';
import EditIcon from '@material-ui/icons/EditOutlined';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import TagsIcon from '@material-ui/icons/LocalOfferOutlined';
import MoreIcon from '@material-ui/icons/MoreHorizOutlined';
import TableIcon from '@material-ui/icons/TableChartOutlined';
import DetailIcon from '@material-ui/icons/DetailsOutlined';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import SettingIcon from '@material-ui/icons/SettingsEthernetOutlined';
import LockIcon from '@material-ui/icons/LockOutlined';
import AddIcon from '@material-ui/icons/Add';
import IconButton from '@material-ui/core/IconButton';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import "react-toggle/style.css";
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
/* Redux */
import { bindActionCreators } from 'redux';
import { CustomTableCell, TablePaginationActionsWrapped } from '..';
import { getWidthColumnByPercent } from '../../../lib/components/function';
import { safeDeepGetWithType } from 'iotera-base/json';
import { isInteger, isFunction, isNone } from 'iotera-base/object';
import { actions as notificationActions } from '../../../redux/ducks/notification';
import { S } from '../../../routes/routes';
import { withRouter } from 'react-router-dom';

/* React Confirm Alert */
import { ioteraConfirmAlert } from '../../../lib/components/react/react-confirm-alert';
import { DEVICE_CAT_MQTT, DEVICE_CAT_TASMOTA, DEVICE_CAT_LORA, DEVICE_CAT_UI, DEVICE_CAT_ZLAN, DEVICE_CAT_BIVOCOM, DEVICE_CAT_FRIENDCOM, DEVICE_CAT_IOTERA, DEVICE_CAT_IMOU_CAMERA, DEVICE_CAT_EMMA } from '../../../lib/components/Preference';

let colors = ['#7E57C2'];

const formatTime = ts => {
  if (!isNone(ts)) {
    return (
      new Date(ts).toLocaleDateString('en-GB') +
      ' ' +
      new Date(ts).toLocaleTimeString('en-GB')
    );
  } else {
    return '-';
  }
};

class ComponentTable extends Component {
  constructor(props) {
    super(props);
    // kodingan tambahan
    this.page_ = 0
    this.rowsPerPage_ = 25
    this.filterSearchFinish_ = false

    this.toggle = this.toggle.bind(this);
    this.goTo = this.goTo.bind(this);
    this.state = {
      tooltipOpen: false,
      page: 0,
      rowsPerPage: 25,
      dropdownOpen: {}
    };
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleAddDummy = this.handleAddDummy.bind(this);
  }

  // kodingan tambahan
  componentDidMount() {
    this.page_ = parseInt(sessionStorage.getItem('page'))
    this.rowsPerPage_ = parseInt(sessionStorage.getItem('rows_per_page'))
    if (isNaN(this.page_)) {
      this.page_ = 0
    }
    if (isNaN(this.rowsPerPage_)) {
      this.rowsPerPage_ = 25
    }
    this.setState({ page: this.page_, rowsPerPage: this.rowsPerPage_ })
  }

  // kodingan tambahan
  componentDidUpdate() {
    const data_ = this.props.data
    const totalPage = Math.ceil((data_.length / this.state.rowsPerPage) - 1)
    sessionStorage.setItem('page', this.state.page)
    sessionStorage.setItem('rows_per_page', this.state.rowsPerPage)
    // while doing searching
    if ((totalPage < this.state.page) && (!this.filterSearchFinish_)) {
      this.filterSearchFinish_ = true
      this.setState({ page: 0, rowsPerPage: 25 })
    }
  }

  handleAddDummy(id) {
    let handleAdd = safeDeepGetWithType(this, ['props', 'handleAdd']);
    if (isFunction(handleAdd)) {
      handleAdd(id);
    }
  }

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    let rowsPerPage = event.target.value;
    if (!isInteger(rowsPerPage))
      rowsPerPage = parseInt(rowsPerPage)
    this.setState({ page: 0, rowsPerPage });
  };

  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }

  onMouseEnter(key) {
    let dropdownOpen = Object.assign({}, this.state.dropdownOpen);
    // set dropdown visible 
    dropdownOpen[key] = true;
    this.setState({ dropdownOpen });
  }

  onMouseLeave(key) {
    let dropdownOpen = Object.assign({}, this.state.dropdownOpen);
    // set dropdown hidden 
    dropdownOpen[key] = false;
    this.setState({ dropdownOpen });
  }

  handleAllCheck = event => {
    this.props.data.forEach((device, index, devices) => {
      devices[index].selected = event.target.checked
    })
    this.props.onCheckedDevice(event.target.checked)
  }

  handleCheck = (index, event) => {
    this.props.data[index].selected = event.target.checked
    this.props.onCheckedDevice(event.target.checked)
  }

  handleDelete = (deviceid, devicetype) => event => {
    let handleDelete = safeDeepGetWithType(this, ['props', 'handleDelete']);
    if (isFunction(handleDelete)) {
      ioteraConfirmAlert(
        'Konfirmasi Hapus Perangkat',
        'Apakah anda yakin ingin menghapus perangkat ini?',
        null,
        () => handleDelete(deviceid, devicetype),
        null,
        null
      )
    }
  }

  goTo(link) {
    if (link === 'delete') {
      this.props.showSingleNotification({ message: 'Maaf, fitur hapus perangkat belum tersedia', position: 'tr', level: 'info' });
    } else if (link === 'emptyTag') {
      this.props.showSingleNotification({ message: 'Maaf, fitur hapus perangkat belum tersedia', position: 'tr', level: 'info' });
    } else {
      this.props.history.push(link)
    }
  }

  render() {
    let data = this.props.data;
    const allTags = safeDeepGetWithType(this, ['props', 'tags'], {});
    const allTagsLength = Object.keys(allTags).length
    let tableWidth = safeDeepGetWithType(this, ['props', 'tableSize', 'width'], 0);
    const { rowsPerPage, page } = this.state;
    let deviceRows = []
    let firstMore = true;
    let alreadyMore = false;
    Object.keys(data).forEach((key, index) => {
      let cardContent = data[key];
      let tags = []
      let tagsMore = []
      let activeText = ""
      let j = 0;
      let k = 0;
      let sizeTags = 0;
      let sizeTagsMore = 0;
      let tagsObj = { ...safeDeepGetWithType(cardContent, ['tags'], {}) };
      let color = colors[Math.floor(Math.random() * colors.length)];
      for (let core in tagsObj) {
        if (tagsObj.hasOwnProperty(core)) {
          let tagsArr = tagsObj[core];
          for (let i = 0; i < tagsArr.length; i++) {
            let tagDef = tagsArr[i];
            let initialTag = core.substring(0, 1) + tagDef.substring(0, 1);
            let tagFull =
              <span key={core + k++} href='#' className='text-white'>{'{' + core + ':' + tagDef + '}'}</span>
            let defWidth = getWidthColumnByPercent(35, tableWidth)
            if (defWidth > 100) {
              defWidth -= 36
            }
            if (sizeTags + 1 > defWidth / 36) {
              alreadyMore = true;
            }
            if ((sizeTags >= defWidth / 36) || (alreadyMore === true)) {
              // TODO +icon
              if (firstMore === true) {
                firstMore = false;
              } else {
                tagsMore.push(<span key={core + k++} className='text-white'>,&nbsp;</span>)
              }
              sizeTagsMore++;
              tagsMore.push(
                <span key={core + k++} href='#' className='text-white'>{tagFull}</span>
              )
            } else {
              sizeTags++;
              tags.push(
                <span key={core + i}>
                  <Tooltip TransitionComponent={Zoom} title={tagFull} placement='bottom-start' enterDelay={500} >
                    <span className="numberCircle" style={{ backgroundColor: color, borderColor: color }} >
                      {initialTag.toUpperCase()}
                    </span>
                  </Tooltip>
                </span>
              )
            }
          }
        } else {
          tags.push(
            '-'
          )
        }
      }
      if (((sizeTags >= 6) && (sizeTagsMore !== 0)) || (alreadyMore === true)) {
        let textMore = sizeTagsMore > 9 ? '+' : sizeTagsMore;
        tags.push(
          <span key={key + j++}>
            <Tooltip TransitionComponent={Zoom} title={tagsMore} placement='bottom-start' enterDelay={500} >
              <span className="numberCircle" style={{ backgroundColor: color, borderColor: color }} >{'+' + textMore}</span>
            </Tooltip>
          </span>
        )
      }
      const last_online_ts = cardContent['last_online_ts'];
      const last_offline_ts = cardContent['last_offline_ts'];
      if (cardContent['online']) {
        activeText = <Tooltip title={'Last Online: ' + formatTime(last_online_ts) + ' / Last Offline: ' + formatTime(last_offline_ts)} leaveDelay={500} interactive><span style={{ color: '#4D2C91' }}>Nyala</span></Tooltip>
      } else {
        activeText = <Tooltip title={'Last Online: ' + formatTime(last_online_ts) + ' / Last Offline: ' + formatTime(last_offline_ts)} leaveDelay={500} interactive><span style={{ color: '#FD2623' }}>Mati</span></Tooltip>
      }
      const disabled = cardContent['disabled'];
      // get dropdown is open or not
      let dropdownIsOpen = safeDeepGetWithType(this, ['state', 'dropdownOpen', index], false);
      deviceRows.push(
        <TableRow key={index} className='table-row-child-iotera' >
          <TableCell component="th" scope="row" column='device' style={{ textAlign: 'left' }}>
            <span>
              <span>{cardContent.name}</span><span className='text-muted'>{' (' + cardContent.deviceType[0] + ')'}</span>{disabled ? <span>{' '}<LockIcon fontSize='inherit'/></span> : <></>}<br />
              <span className='font-italic text-muted'>{cardContent.id}</span>
            </span>
          </TableCell>
          <TableCell column='status' style={{ textAlign: 'left' }}>
            <span>
              {activeText}
            </span>
          </TableCell>
          <TableCell column='serialnumber' style={{ textAlign: 'left' }}>
            <span>
              {cardContent.serial}
            </span>
          </TableCell>
          <TableCell column='tags'>
            <span>
              {tags}
            </span>
          </TableCell>
          <TableCell column='settings' style={{ textAlign: 'center' }} onMouseLeave={(e) => this.onMouseLeave(index)}>
            <UncontrolledDropdown isOpen={dropdownIsOpen}>
              <DropdownToggle tag="div">
                <IconButton onMouseOver={(e) => this.onMouseEnter(index)} style={{ cursor: 'pointer', padding: 4 }}>
                  <MoreIcon color="inherit" style={{ height: 30, width: 30 }} />
                </IconButton>
              </DropdownToggle>
              <DropdownMenu
                modifiers={{
                  setMaxHeight: {
                    enabled: true,
                    order: 890,
                    fn: (data) => {
                      return {
                        ...data,
                        styles: {
                          ...data.styles,
                          overflow: 'auto',
                          maxHeight: 200,
                        },
                      };
                    },
                  },
                }}
                style={{ padding: 0, margin: 0 }}>
                <DropdownItem style={{ margin: 0 }} onClick={(e) => 
                  this.handleAddDummy(cardContent.id)}>
                  <AddIcon color="inherit" style={{ height: 18, width: 18 }} />
                  &emsp;<span style={{ marginRight: 20 }}>Dashboard</span>
                </DropdownItem>
                <DropdownItem style={{ margin: 0 }} onClick={(e) => 
                  this.goTo('.' + S + '_device_data_all_' + S + cardContent.id)}>
                  <TableIcon color="inherit" style={{ height: 18, width: 18 }} />
                  &emsp;<span style={{ marginRight: 20 }}>Semua Data</span>
                </DropdownItem>
                <DropdownItem style={{ margin: 0 }} onClick={(e) => 
                  this.goTo('.' + S + '_device_data_detail_' + S + cardContent.id)}>
                  <DetailIcon color="inherit" style={{ height: 18, width: 18 }} />
                  &emsp;<span style={{ marginRight: 20 }}>Daftar Sensor</span>
                </DropdownItem>
                <DropdownItem style={{ margin: 0 }} onClick={(e) => 
                  this.goTo('.' + S + '_device_state_' + S + cardContent.id)}>
                  <CheckCircleOutlineIcon color="inherit" style={{ height: 18, width: 18 }} />
                  &emsp;<span style={{ marginRight: 20 }}>Daftar Kondisi</span>
                </DropdownItem>
                <DropdownItem style={{ margin: 0 }} onClick={(e) => 
                  this.goTo('.' + S + '_device_edit_' + S + 'info' + S + cardContent.id)}>
                  <EditIcon color="inherit" style={{ height: 18, width: 18 }} />
                  &emsp;<span style={{ marginRight: 20 }}>Edit Info</span>
                </DropdownItem>
                {cardContent.category === DEVICE_CAT_LORA &&
                  <DropdownItem style={{ margin: 0 }} onClick={(e) => 
                  this.goTo('.' + S + '_device_edit_' + S + 'info' + S + cardContent.category + S + cardContent.id)}>
                    <InfoIcon color="inherit" style={{ height: 18, width: 18 }} />
                    &emsp;<span style={{ marginRight: 20 }}>Lora</span>
                  </DropdownItem>}
                {cardContent.category === DEVICE_CAT_MQTT &&
                  <DropdownItem style={{ margin: 0 }} onClick={(e) => 
                  this.goTo('.' + S + '_device_edit_' + S + 'info' + S + DEVICE_CAT_MQTT + S + cardContent.id)}>
                    <InfoIcon color="inherit" style={{ height: 18, width: 18 }} />
                    &emsp;<span style={{ marginRight: 20 }}>MQTT</span>
                  </DropdownItem>}
                {cardContent.category === DEVICE_CAT_TASMOTA &&
                  <DropdownItem style={{ margin: 0 }} onClick={(e) => 
                  this.goTo('.' + S + '_device_edit_' + S + 'info' + S + DEVICE_CAT_TASMOTA + S + cardContent.id)}>
                    <InfoIcon color="inherit" style={{ height: 18, width: 18 }} />
                    &emsp;<span style={{ marginRight: 20 }}>Tasmota</span>
                  </DropdownItem>}
                {cardContent.category === DEVICE_CAT_UI &&
                  <DropdownItem style={{ margin: 0 }} onClick={(e) => 
                  this.goTo('.' + S + '_device_edit_' + S + 'info' + S + cardContent.category + S + cardContent.id)}>
                    <InfoIcon color="inherit" style={{ height: 18, width: 18 }} />
                    &emsp;<span style={{ marginRight: 20 }}>USR-IOT</span>
                  </DropdownItem>}
                {cardContent.category === DEVICE_CAT_ZLAN &&
                  <DropdownItem style={{ margin: 0 }} onClick={(e) => 
                  this.goTo('.' + S + '_device_edit_' + S + 'info' + S + cardContent.category + S + cardContent.id)}>
                    <InfoIcon color="inherit" style={{ height: 18, width: 18 }} />
                    &emsp;<span style={{ marginRight: 20 }}>ZLAN</span>
                  </DropdownItem>}
                {cardContent.category === DEVICE_CAT_BIVOCOM &&
                  <DropdownItem style={{ margin: 0 }} onClick={(e) => 
                  this.goTo('.' + S + '_device_edit_' + S + 'info' + S + cardContent.category + S + cardContent.id)}>
                    <InfoIcon color="inherit" style={{ height: 18, width: 18 }} />
                    &emsp;<span style={{ marginRight: 20 }}>Bivocom</span>
                  </DropdownItem>}
                {cardContent.category === DEVICE_CAT_FRIENDCOM &&
                  <DropdownItem style={{ margin: 0 }} onClick={(e) => 
                  this.goTo('.' + S + '_device_edit_' + S + 'info' + S + cardContent.category + S + cardContent.id)}>
                    <InfoIcon color="inherit" style={{ height: 18, width: 18 }} />
                    &emsp;<span style={{ marginRight: 20 }}>Friendcom</span>
                  </DropdownItem>}
                {cardContent.category === DEVICE_CAT_IOTERA &&
                  <DropdownItem style={{ margin: 0 }} onClick={(e) => 
                  this.goTo('.' + S + '_device_edit_' + S + 'info' + S + cardContent.category + S + cardContent.id)}>
                    <InfoIcon color="inherit" style={{ height: 18, width: 18 }} />
                    &emsp;<span style={{ marginRight: 20 }}>Iotera</span>
                  </DropdownItem>}
                {cardContent.category === DEVICE_CAT_EMMA &&
                  <DropdownItem style={{ margin: 0 }} onClick={(e) => 
                  this.goTo('.' + S + '_device_edit_' + S + 'info' + S + cardContent.category + S + cardContent.id)}>
                    <InfoIcon color="inherit" style={{ height: 18, width: 18 }} />
                    &emsp;<span style={{ marginRight: 20 }}>Emma</span>
                  </DropdownItem>}
                {cardContent.category === DEVICE_CAT_IMOU_CAMERA &&
                  <DropdownItem style={{ margin: 0 }} onClick={(e) => 
                  this.goTo('.' + S + '_device_edit_' + S + 'info' + S + cardContent.category + S + cardContent.id)}>
                    <InfoIcon color="inherit" style={{ height: 18, width: 18 }} />
                    &emsp;<span style={{ marginRight: 20 }}>Imou Camera</span>
                  </DropdownItem>}
                <DropdownItem style={{ margin: 0 }} onClick={(e) => 
                  this.goTo('.' + S + '_device_edit_' + S + 'sensors' + S + cardContent.id)}>
                  <SettingIcon color="inherit" style={{ height: 18, width: 18 }} />
                  &emsp;<span style={{ marginRight: 20 }}>Konfigurasi</span>
                </DropdownItem>
                {allTagsLength > 0 ?
                  <DropdownItem style={{ margin: 0 }} onClick={(e) => 
                  this.goTo('.' + S + '_device_edit_' + S + 'tag' + S + cardContent.id)}>
                    <TagsIcon color="inherit" style={{ height: 18, width: 18 }} />
                    &emsp;<span style={{ marginRight: 20 }}>Penanda</span>
                  </DropdownItem>
                  :
                  null
                }
                <DropdownItem style={{ margin: 0 }} onClick={this.handleDelete(cardContent.id, cardContent.category)}>
                  <DeleteIcon color="inherit" style={{ height: 18, width: 18 }} />&emsp;<span style={{ marginRight: 20 }}>Hapus</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </TableCell>
        </TableRow>
      )
      firstMore = true;
      alreadyMore = false;
    }
    )
    return (
      <Table className="table">
        <TableHead style={{ height: 0 }}>
          <TableRow>
            <CustomTableCell column='device' style={{ textAlign: 'left', minWidth: getWidthColumnByPercent(30, tableWidth),
             maxWidth: getWidthColumnByPercent(30, tableWidth) }}><span>Perangkat</span></CustomTableCell>
            <CustomTableCell column='status' style={{ textAlign: 'left', minWidth: getWidthColumnByPercent(10, tableWidth), 
            maxWidth: getWidthColumnByPercent(10, tableWidth) }}><span>Status</span></CustomTableCell>
            <CustomTableCell column='serialnumber' style={{ textAlign: 'left', minWidth: getWidthColumnByPercent(15, tableWidth),
             maxWidth: getWidthColumnByPercent(15, tableWidth) }}><span>Nomor Serial</span></CustomTableCell>
            <CustomTableCell column='tags' style={{ textAlign: 'left', minWidth: getWidthColumnByPercent(35, tableWidth), 
            maxWidth: getWidthColumnByPercent(35, tableWidth) }}><span>Penanda</span></CustomTableCell>
            <CustomTableCell column='settings' style={{ textAlign: 'center', minWidth: getWidthColumnByPercent(10, tableWidth), 
            maxWidth: getWidthColumnByPercent(10, tableWidth) }}><span>Aksi</span></CustomTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {deviceRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              labelDisplayedRows={({ from, to, count }) => `${from}-${to} dari ${count}`}
              labelRowsPerPage='Baris terlihat:'
              rowsPerPageOptions={[25, 50, 100]}
              count={data.length}
              rowsPerPage={rowsPerPage}
              page={page} //default is page
              SelectProps={{
                native: true,
              }}
              onPageChange={this.handleChangePage}
              onChangeRowsPerPage={this.handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActionsWrapped}
            />
          </TableRow>
        </TableFooter>
      </Table>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(notificationActions, dispatch)
});

export default connect(null, mapDispatchToProps)(withRouter(ComponentTable));